import ModerationRoute from './_config/portail.moderation.routes';
import portailModerationList from './components/moderation-list';

const moduleName = 'app.massia.common.portail.moderation';

angular.module(moduleName, []).config(ModerationRoute).component('portailModerationList', portailModerationList);
export default moduleName;
